
















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class TrackingButtons extends Vue {
  @Prop()
  showPanelCamera!: () => void

  @Prop()
  trackingUserSelected!: () => void
}
